"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class NetworkFilesystem {
    constructor(root = "http://localhost") {
        this.root = root;
    }
    delete(path) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("delete not implemented on network filesystem");
        });
    }
    exists(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((res, rej) => {
                fetch(this.root + "/" + path)
                    .then(response => {
                    res(response.ok);
                });
            });
        });
    }
    read(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((res, rej) => {
                fetch(this.root + "/" + path)
                    .then(data => {
                    if (!data.ok) {
                        rej("Failed to read file");
                    }
                    res(data.body);
                });
            });
        });
    }
    readText(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((res, rej) => {
                fetch(this.root + "/" + path)
                    .then((response) => {
                    response.text().then((text) => res(text));
                });
            });
        });
    }
    write(path, content) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("write not implemented on network filesystem");
        });
    }
}
exports.NetworkFilesystem = NetworkFilesystem;
